import React from "react";

import SinglePhotoDropzone from "../SinglePhotoDropzone/SinglePhotoDropzone";
import SinglePhotoProcessing from "../SinglePhotoProcessing/SinglePhotoProcessing";

function ComparisonPhotoProcessing(props) {
  return (
    <div
      className="flex flex-col md:flex-row items-center justify-center w-full md:h-[45rem] md:min-h-[45rem] 
                 space-y-4 md:space-y-0 md:space-x-4
                 Xbg-blue-500"
    >
      <SinglePhotoDropzone
        comparisonItem={props.comparisonItem}
        comparisonItems={props.comparisonItems}
        setComparisonItems={props.setComparisonItems}
        index={props.index}
        setFileKey={"fileOne"}
        modalImage={props.modalImage}
        setModalImage={props.setModalImage}
        entryBrowserModalOpen={props.entryBrowserModalOpen}
        setEntryBrowserModalOpen={props.setEntryBrowserModalOpen}
        comparisonItemLocation={props.comparisonItemLocation}
        setComparisonItemLocation={props.setComparisonItemLocation}
        calculationProgress={props.calculationProgress}
        rapidEntry={props.rapidEntry}
      />

      <SinglePhotoProcessing
        comparisonItem={props.comparisonItem}
        comparisonItems={props.comparisonItems}
        setComparisonItems={props.setComparisonItems}
        index={props.index}
        setFileKey={"fileTwo"}
        modalImage={props.modalImage}
        setModalImage={props.setModalImage}
        imageProcessingStatuses={props.imageProcessingStatuses}
        // setImageProcessingStatuses={props.setImageProcessingStatuses}
      />
    </div>
  );
}

export default ComparisonPhotoProcessing;
